/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useAppSelector } from '@/hooks';
import { useTranslations } from '@/hooks/useTranslations';
import { Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

const TaskTitle = () => {
    const { t } = useTranslations();
    const productList = useAppSelector(state => state.productList);
    const { currentStep } = productList;
    return (
        <Title
            data-testid="task-title"
            level="H1"
            style={{
                marginBottom: ThemingParameters.sapContent_Margin_Small,
                fontSize: ThemingParameters.sapFontHeader4Size,
            }}
        >
            {t({ key: currentStep?.translationTitleKey ?? '', defaultText: currentStep?.name })}
        </Title>
    );
};

export default TaskTitle;
